import { useEffect, useState } from "react";
import GroupEditIcon from "./partial/GroupEditIcon.js";
import Loading from "./partial/Loading.js";
import { _getGroup, _changeGroupName } from "../data/groups";
import { auth } from "../utils/firebase";
import { useNavigate } from "react-router-dom";
import { toggleModal } from "../utils/uiUtils";
import Failure from "./partial/Failure.js";
import GroupEditBackground from "./partial/GroupEditBackground.js";
import { useEnsureGroupData } from "../hooks/useEnsureGroupData.js";
import { useCurrentGroupStore } from "../stores/useCurrentGroupStore.js";


function GroupSettings({ groupId }) {
    useEnsureGroupData(groupId);

    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const _updateCachedGroupName = useCurrentGroupStore((state) => state.setGroupName);
    const group = useCurrentGroupStore((state) => state.group);

    useEffect(() => {
        setIsAdmin(group.groupAdmins.includes(auth.currentUser.uid));
        setIsLoading(false);
    }, [group]);

    if (isLoading) {
        return (
            <Loading />
        )
    }

    const changeGroupName = async () => {
        var groupName = document.getElementById("groupNameField").value;
        if (groupName.trim() === group.groupName.trim()) {
            return;
        }

        var success = await _changeGroupName(groupId, groupName);
        if (success) {
           _updateCachedGroupName(groupName);
        } else {
            toggleModal("modal-error");
        }
    }

    const groupNameChange = () => {
        if (!isAdmin) {
            return (<></>);
        }

        return (
            <>
                <div className="mr-auto ml-auto has-text-weight-semibold is-size-5">
                    Change Group Name
                </div>
                <div className="field has-addons">
                    <div className="control">
                        <input id="groupNameField" className="input" type="text" maxLength="50" defaultValue={group.groupName} />
                    </div>
                    <div className="control" onClick={() => { changeGroupName(); }}>
                        <button className="button is-primary" >
                            Save
                        </button>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <header className="has-text-centered mb-4">
                <p className="subtitle">Group Settings</p>
            </header>

            {groupNameChange()}

            <GroupEditIcon groupId={groupId} />

            <GroupEditBackground groupId={groupId} />

            <div id="modal-error" className="modal">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-text-centered">
                        <p className="modal-card-title">Something went wrong</p>
                        <button className="delete" aria-label="close" onClick={() => { document.getElementById('modal-error').classList.remove('is-active') }}></button>
                    </header>
                    <section className="modal-card-body">
                        <Failure message={"Looks like that action didn't work. Make sure you have permissions and try again"} isNotFullHeight={true} />
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button" aria-label="close" onClick={() => { document.getElementById('modal-error').classList.remove('is-active') }}>Close</button>
                    </footer>
                </div>
            </div>
        </>
    )
}

export default GroupSettings;